<template>
  <div>
    <template
      v-for="block in column.blocks"
      :key="`column_${block.name}`"
    >
      <app-component-loader
        class="block"
        :objects="{ column, block }"
        :component-path="block.component_path"
      />
    </template>
  </div>
</template>

<script setup>
import AppComponentLoader from '&/atoms/AppComponentLoader'

defineProps({ column: { type: Object, required: true } })
</script>

<style lang="scss" scoped>
.block {
  &:not(:last-child) {
    margin-bottom: 18px;
  }
}
</style>